// ----------------------------------------------------------------------------
// Component: Yotpo Review Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_pr-reviews.scss';
